<template>
    <div
        class="card-view"
        :class="[{ dimmed: dimmed, 'card-view-editing': isEditing }, className]"
    >
        <div class="card-view-header" @dblclick="$emit('dbclick:head')">
            <span class="card-view-header-title">{{ label }}</span>
            <slot name="slot-header"></slot>
            <span class="card-view-setting">
                <b-tooltip
                    :label="resetLabel"
                    type="is-light"
                    position="is-bottom"
                >
                    <img
                        src="/static/assets/img/proposal/retrieve_icon.png"
                        v-if="resetable"
                        @click="$emit('edit:reset')"
                    />
                </b-tooltip>
                <slot name="setting">
                    <div
                        class="card-view-setting-wrapper"
                        @click="$emit('edit:start')"
                    >
                        <span
                            class="card-view-setting-text"
                            v-if="cardType === 'locations'"
                            >{{ settingLabel }}</span
                        >
                        <img
                            :src="settingImgSrc"
                            v-if="editable && !isEditing"
                            class="card-view-setting-icon"
                            v-tooltip="{
                                content: settingLabel,
                                visible: !!settingLabel,
                            }"
                        />
                    </div>
                </slot>
                <b-tooltip
                    :label="confirmLabel"
                    type="is-light"
                    position="is-bottom"
                >
                    <img
                        src="/static/assets/img/proposal/edit_ok_icon.png"
                        v-if="editable && isEditing"
                        @click="$emit('edit:end')"
                    />
                </b-tooltip>
            </span>
        </div>
        <div class="card-view-body" v-bind:class="{ isTop: isTop }">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isEditableAlways: {
            type: Boolean,
            default: false,
        },
        isEditing: {
            type: Boolean,
            default: false,
        },
        editable: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            required: false,
        },
        dimmed: {
            type: Boolean,
            required: false,
        },
        resetLabel: {
            type: String,
        },
        confirmLabel: {
            type: String,
        },
        settingLabel: {
            type: String,
        },
        className: {
            type: [String, Array],
            default: '',
        },
        resetable: {
            type: Boolean,
            default: false,
        },
        settingImgSrc: {
            type: String,
            default: '/static/assets/img/proposal/edit_icon.png',
        },
        cardType: {
            type: String,
            default: '',
        },
        isTop: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss">
.card-view {
    position: relative;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0px 3px 12px 0 rgba(0, 0, 0, 0.05);
    color: $color7;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    flex-direction: column;

    .card-view-header-title,
    .card-title {
        font-family: $font-common;
        font-weight: 600;
        color: #4d5058;
        font-size: 14px;
    }

    .card-view-header {
        background-color: $color8;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        height: 45px;
        flex-shrink: 0;
    }

    .card-view-body {
        padding: 15px;
        height: calc(100% - 45px);
    }

    &.card-view-editing {
        .card-view-header {
            background-color: $color37;
        }
    }

    .card-view-header {
        padding-left: 15px;
        padding-right: 15px;
        border-bottom: 1px solid $color5;
        display: flex;
        align-items: center;
        position: relative;
    }

    .card-view-setting {
        position: absolute;
        right: 10px;
        margin-top: 1px;
        display: flex;
        justify-content: center;
        align-items: center;

        &-wrapper {
            position: relative;
            bottom: 2px;
        }
        &-text {
            font-size: 13px;
            cursor: pointer;
        }

        img {
            cursor: pointer;
            margin: 0 5px;
        }

        @media screen and (max-width: 799px) {
            top: 9px;
        }
    }
}

.card-view.dimmed::before {
    border-radius: 5px;
    content: '';
    background: #fff;
    opacity: 0.6;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
}

@media screen and (max-width: 799px) {
    .card-view {
        .card-view-header {
            height: 40px;
        }
    }
}

@media screen and (min-width: 800px) {
    .card-view.dimmed::before {
        border-radius: 5px;
        content: '';
        background: #fff;
        opacity: 0.6;
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 1;
    }
}
</style>

<style lang="scss">
.card-one-third {
    height: 200px;
    width: 325px;
    display: inline-block;
    vertical-align: top;
    margin-bottom: 15px;

    .card-view-header {
        height: 45px;
    }

    .card-view-body {
        height: 155px;
    }
}

.card-half {
    width: 494px;
    height: 200px;
    display: inline-block;
    vertical-align: top;
    margin-bottom: 15px;

    .card-view-header {
        height: 45px;
    }

    .card-view-body {
        height: 155px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}

.profile-no-contents-text {
    font-family: $font-common;
    font-size: 12px;
    color: $color6;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
}

.profile-add-action-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: $font-common;
    font-weight: 500;
    font-size: 12px;
    color: $color1;
    line-height: 16px;
    background-color: $color34;
    width: 100%;
    margin-top: auto;
    height: 30px;
    border-radius: 3px;

    img {
        margin-right: 7px;
    }
}
</style>
